import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-movie-2-fill text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-50">
              6080<span className="text-primary-500">电影网</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 8).map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap hover:bg-background-100 ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-background-100'
                    : 'text-foreground-300 hover:text-foreground-50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-300 hover:text-foreground-50 transition-colors whitespace-nowrap"
            >
              关于我们
            </Link>
            <button className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer">
              <i className="ri-search-line text-foreground-300 text-lg"></i>
            </button>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`text-foreground-300 text-lg ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 animate-fade-in">
          <div className="px-4 py-3 grid grid-cols-4 gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={cat.slug === 'all' ? '/' : `/category/${cat.slug}`}
                className={`flex flex-col items-center gap-1 p-2 rounded-lg text-xs transition-colors ${
                  (cat.slug === 'all' && location.pathname === '/') ||
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-background-100'
                    : 'text-foreground-300 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
          </div>
          <div className="px-4 pb-4">
            <Link
              to="/about"
              className="block w-full text-center py-2 text-sm text-foreground-300 hover:text-foreground-50 transition-colors"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}